import React, { useState } from 'react';
import { Query } from 'react-apollo';

import IbePropTypes from '../../IbePropTypes';

const SafeQuery = ({ fallback, children, ...rest }) => {
  const [error, setError] = useState(null);

  return (
    <Query {...rest} onError={setError}>
      {(...args) => {
        if (error) {
          return fallback;
        }
        return children(...args);
      }}
    </Query>
  );
};

SafeQuery.propTypes = {
  fallback: IbePropTypes.reactNode,
  children: IbePropTypes.children.isRequired,
};

SafeQuery.defaultProps = {
  fallback: <></>,
};

export default SafeQuery;
